import { FC } from "react";
import { Outlet, Navigate } from "react-router-dom";
interface PrivateRoutesProps {
  browseWithoutLogin?: boolean;
  isConfigLoading?: boolean;
}


const PrivateRoutes: FC<PrivateRoutesProps> = ({ browseWithoutLogin = false, isConfigLoading = false }) => {
  let auth = localStorage.getItem("Token");
  if (isConfigLoading) {
    return <Outlet />;
  }
  if (browseWithoutLogin) {
    return <Outlet />;
  }
  return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
